import React from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../constants/aampeTheme';

// hooks
import useAnalytics from '../../hooks/helper/useAnalytics';

import AUTH from '../../services/auth';

interface ProviderProps {
    logo: any;
    SSOProviderName: string;
    callbackUrl: string;
    buttonText?: string;
    noWhiteBackground?: boolean;
}

const ProviderBase: React.FC<React.PropsWithChildren<ProviderProps>> = ({
    logo,
    SSOProviderName,
    callbackUrl,
    buttonText,
    noWhiteBackground = false,
}) => {
    const { track } = useAnalytics();

    return (
        <StyledButton
            onClick={() =>
                AUTH.signInWithProvider({
                    track,
                    provider: SSOProviderName,
                    callbackUrl,
                })
            }
        >
            <Logo $noWhiteBackground={noWhiteBackground}>{logo}</Logo>
            <span>{buttonText || SSOProviderName}</span>
        </StyledButton>
    );
};

export default ProviderBase;

const StyledButton = styled.button({
    all: 'unset',
    height: aampeTheme.size.inputHeight.default,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
    color: aampeTheme.colors.gray800,
    fontWeight: 600,
    fontSize: '16px',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#4285F4',
        color: '#fff',
        fill: aampeTheme.colors.white,
        border: '1px solid transparent',
    },
    '&.active': {
        backgroundColor: 'yellow',
    },
});

const Logo = styled.span<{ $noWhiteBackground?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${aampeTheme.borderRadius.default};
    height: 30px;
    width: 30px;
    margin-right: ${aampeTheme.spacing(2)};
    ${({ $noWhiteBackground }) =>
        !$noWhiteBackground && `background-color: ${aampeTheme.colors.white};`}
`;
